import { createAsyncThunk } from '@reduxjs/toolkit';
import { orderBy } from 'lodash';
import moment from 'moment';
import { billingProcessService } from 'services';
import { invoice_detail_simple_results, ItemLinkInspecRequest, OtherDetail } from 'types';

export const getListBills = createAsyncThunk<any, any>('billList/getListBill', async (params) => {
  try {
    const conditions: any[] = [
      {
        id: 'Status',
        search_value: ['progress'],
        not_match: true,
      },
    ];
    params.search.facility_code &&
      conditions.push({
        id: 'facility_code',
        search_value: [params.search.facility_code],
      });
    params.search.facility_name &&
      conditions.push({
        id: 'facility_name',
        search_value: [params.search.facility_name],
      });
    const invoice_month = params.search.year + params.search.month;
    invoice_month &&
      conditions.push({
        id: 'invoice_month',
        search_value: [invoice_month],
      });
    return billingProcessService.searchBills({
      page: params.page,
      conditions: conditions,
      sort_fields: [
        { id: 'invoice_month', order: 'desc' },
        { id: 'facility_code', order: 'asc' },
      ],
    });
  } catch (error) {}
});

export const getDataExportBill = createAsyncThunk<any, any>('billList/getDataExportBill', async (param) => {
  try {
    const formatter = new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
    });

    const { data } = await billingProcessService.getBillDetail({ i_id: param.i_id });
    if (data.field_values.Status.value !== 'closed' && data.field_values.Status.value !== 'payment') {
      billingProcessService.executeAction({
        i_id: param.i_id,
        action: 'a_invoice_issued',
        item: { status: 'a_invoice_issued' },
      });
    }
    const { data: medical } = await billingProcessService.getMedicalDetail({
      item_id: data.field_values.facility_id.value.item_id,
    });
    const { data: hospitals } = await billingProcessService.searchHospital({
      page: 1,
      per_page: 0,
      conditions: [
        {
          search_value: [param.i_id],
          id: 'invoice_id',
          include_null: false,
          exact_match: true,
        },
      ],
      sort_fields: [
        { id: 'sort_num', order: 'asc' },
        { id: 'cpap_id', order: 'asc' },
        { id: 'target_month', order: 'desc' },
      ],
      include_lookups: false,
    });

    const { data: dataPsg } = await billingProcessService.getInvoiceDetailPSG({ invoice_id: param.invoice_id });
    const { data: dataOther } = await billingProcessService.getInvoiceOtherDetail({ invoice_id: param.invoice_id });
    const { data: dataInspectionDetail } = await billingProcessService.getItemLinkInspec({
      invoice_id: param.invoice_id,
    });

    const psgDetail = dataPsg?.report_results ? dataPsg.report_results : [];
    const inspectionDetail = dataInspectionDetail?.report_results ? dataInspectionDetail.report_results : [];
    const arrOther = dataOther?.report_results ? dataOther.report_results : [];

    const invoice_month: string = data.field_values.invoice_month.value;
    const Lastdate = new Date(Number(invoice_month.slice(0, 4)), Number(invoice_month.slice(4)), 0);
    const newInvoiceMonth = `${invoice_month.slice(0, 4)}年${Number(invoice_month.slice(4))}月度 (${Number(
      invoice_month.slice(4),
    )}月${Lastdate.getDate()}日 締切分)`;

    const newArrOhterBill =
      arrOther.length > 0
        ? arrOther.map((other: OtherDetail) => {
            return {
              detail_name: other.detail_name ?? '',
              count: other.other_detail_count ?? 0,
              unit_price: other.other_detail_unit_price ?? 0,
              total: Number(other.other_detail_count ?? 0) * Number(other.other_detail_unit_price ?? 0),
            };
          })
        : [];

    const facility = {
      facility_zip: medical.field_values?.facility_zip?.value,
      facility_address1:
        medical.field_values?.facility_address_for_invoice?.value || medical.field_values?.facility_address1?.value,
      facility_address2: medical.field_values?.facility_address_for_invoice?.value
        ? ''
        : medical.field_values?.facility_address2?.value,
      facility_name: medical.field_values?.facility_name_for_invoice?.value || data.field_values?.facility_name?.value,
      facility_code: data.field_values?.facility_code?.value,
    };
    const responseBill = {
      facility: facility,
      invoice_month: newInvoiceMonth,
      last_billed_amount: data.field_values.last_billed_amount.value
        ? formatter.format(data.field_values.last_billed_amount.value)
        : formatter.format(0),
      last_deposit: data.field_values.last_deposit.value
        ? formatter.format(data.field_values.last_deposit.value)
        : formatter.format(0),
      carryover_amount: data.field_values.carryover_amount.value
        ? formatter.format(data.field_values.carryover_amount.value)
        : formatter.format(0),
      total: data.field_values.total.value
        ? formatter.format(Number(data.field_values.total.value))
        : formatter.format(0),
      billing_amount: data.field_values.billing_amount.value
        ? formatter.format(data.field_values.billing_amount.value)
        : formatter.format(0),
      payment_method: data.field_values.payment_method.value ?? '',
      payment_due_date: data.field_values.payment_due_date.value
        ? data.field_values.payment_method.value == '振替'
          ? moment(data.field_values.payment_due_date.value).format('YYYY年M月DD日')
          : moment(data.field_values.payment_due_date.value).endOf('month').format('YYYY年M月DD日')
        : '',
      cpap_count: data.field_values.cpap_count.value ?? '',
      cpap_unit_price: data.field_values.cpap_unit_price.value ?? '',
      cpap_memo:
        Number(data.field_values.cpap_count.value) != 0
          ? `${Number(invoice_month.slice(4))}月1日～${Number(invoice_month.slice(4))}月${Lastdate.getDate()}日`
          : '',
      cpap_unit_sp_price: data.field_values.cpap_unit_sp_price.value ?? '',
      cpap_sp_count: data.field_values.cpap_sp_count.value ?? '',
      cpap_sp_memo:
        Number(data.field_values.cpap_sp_count.value) != 0
          ? `${Number(invoice_month.slice(4))}月1日～${Number(invoice_month.slice(4))}月${Lastdate.getDate()}日`
          : '',
      psg_unit_price: data.field_values.psg_unit_price.value ?? '',
      psg_count: data.field_values.psg_count.value ?? '',
      psg_memo:
        Number(data.field_values.psg_count.value) != 0
          ? `${Number(invoice_month.slice(4))}月1日～${Number(invoice_month.slice(4))}月${Lastdate.getDate()}日`
          : '',
      simplicity_unit_price: data.field_values.simplicity_unit_price.value ?? '',
      simplicity_count: data.field_values.simplicity_count.value ?? '',
      simplicity_memo:
        Number(data.field_values.simplicity_count.value) != 0
          ? `${Number(invoice_month.slice(4))}月1日～${Number(invoice_month.slice(4))}月${Lastdate.getDate()}日`
          : '',
      subtotal: data.field_values.subtotal.value ? Number(data.field_values.subtotal.value) : '',
      tax: data.field_values.tax.value ? Number(data.field_values.tax.value) : '',
      arrOther: newArrOhterBill,
      totalNoUnit: data.field_values.total.value ? Number(data.field_values.total.value) : '',
      totalNoRoundDown: '',
      discountAmount: '',
    };
    responseBill.totalNoRoundDown = `${Number(responseBill.subtotal) + Number(responseBill.tax)}`;
    responseBill.discountAmount = responseBill.totalNoUnit
      ? `${Number(responseBill.totalNoRoundDown) - Number(responseBill.totalNoUnit)}`
      : '';

    const hospitalBills =
      hospitals.totalItems > 0
        ? {
            invoice_month: newInvoiceMonth,
            facility_name: data.field_values?.facility_name?.value,
            facility_code: data.field_values?.facility_code?.value,
            items: hospitals.items.map((v: any) => {
              return {
                patient_id: v.patient_id,
                cpap_id: v.cpap_id ?? '',
                target_month: v.target_month
                  ? `${v.target_month.slice(0, 4)}年${Number(v.target_month.slice(4))}月`
                  : '',
                hospital_visit_remark: v.hospital_visit_remark ?? '',
              };
            }),
          }
        : null;

    const psgBills =
      psgDetail.length > 0
        ? {
            invoice_month: newInvoiceMonth,
            facility_name: data.field_values?.facility_name?.value,
            items: psgDetail.map((v: any) => {
              return {
                name: v.name ?? '',
                inspection_day: v.inspection_day
                  ? `${v.inspection_day.slice(0, 4)}年${Number(v.inspection_day.slice(4))}月`
                  : '',
                psg_remark: v.psg_remark ?? '',
              };
            }),
          }
        : null;
    const inspectionBills =
      inspectionDetail.length > 0
        ? {
            invoice_month: newInvoiceMonth,
            facility_name: data.field_values?.facility_name?.value,
            items: inspectionDetail.map((v: invoice_detail_simple_results) => {
              return {
                name: v.name ?? '',
                inspection_day: v.inspection_day
                  ? `${v.inspection_day.slice(0, 4)}年${Number(v.inspection_day.slice(4))}月`
                  : '',
                simple_inspection_remark: v.simple_inspection_remark ?? '',
              };
            }),
          }
        : null;

    return { responseBill, hospitalBills, psgBills, inspectionBills };
  } catch (error) {}
});

export const getDataCPAPFromHospital = createAsyncThunk<
  any,
  { invoice_id: string; billing_type: string[]; page: number; per_page: number }
>('billList/getDataCPAPFromHospital', async (param) => {
  try {
    const { data } = await billingProcessService.searchCPAPFromHospital({
      invoice_id: param.invoice_id,
      billing_type: param.billing_type,
      page: param.page,
      per_page: param.per_page,
    });
    return data;
  } catch (error) {
    return error;
  }
});

export const getDataCPAPFromHospitalInMonth = createAsyncThunk<
  any,
  { invoice_id: string; billing_type: string; page: number; per_page: number }
>('billList/getDataCPAPFromHospitalInMonth', async (param) => {
  try {
    const { data } = await billingProcessService.searchCPAPFromHospitalInMonth({
      invoice_id: param.invoice_id,
      billing_type: param.billing_type,
      page: 1,
      per_page: 0,
    });
    return data.items;
  } catch (error) {
    return error;
  }
});

export const getDataSimpleInspectionBill = createAsyncThunk<any, ItemLinkInspecRequest>(
  'billList/getDataSimpleInspectionBill',
  async (param) => {
    try {
      const { data } = await billingProcessService.getItemLinkInspec(param);

      return orderBy(data.report_results, ['sort_num', 'created_at'], ['asc', 'asc']);
    } catch (error) {
      return error;
    }
  },
);

export const getDataPSG = createAsyncThunk<any, any>('billList/getDataPSG', async (param) => {
  try {
    const { data } = await billingProcessService.getInvoiceDetailPSG(param);
    return data.report_results;
  } catch (error) {
    return error;
  }
});

export const getDataOther = createAsyncThunk<any, any>('billList/getDataOther', async (param) => {
  try {
    const { data } = await billingProcessService.getInvoiceOtherDetail({ invoice_id: param?.invoice_id });
    return data.report_results;
  } catch (error) {
    return [];
  }
});

export const getDetailInvoice = createAsyncThunk<any, any>('billList/getDetailInvoice', async (param) => {
  try {
    const { data } = await billingProcessService.searchBills({
      conditions: [
        {
          id: 'i_id',
          search_value: [param.i_id],
          include_null: false,
          exact_match: true,
        },
      ],
      page: 1,
      per_page: 1,
      sort_field_id: 'created_at',
      sort_order: 'asc',
    });
    return data.items[0] ?? null;
  } catch (error) {
    return null;
  }
});

export const updateFile = createAsyncThunk<any, any>('thunk/updateFile', async (req) => {
  try {
    const { data } = await billingProcessService.updateFile(req);
    return data;
  } catch (error) {
    return 0;
  }
});

export const updateItemInvoice = createAsyncThunk<any, any>('thunk/updateItemInvoice', async (params) => {
  try {
    const { data } = await billingProcessService.updateItemInvoice(params);
    return data;
  } catch (error) {
    return 0;
  }
});

export const getBillProcessDetail = createAsyncThunk<any, any>('thunk/updateItemInvoice', async (params) => {
  try {
    const { data } = await billingProcessService.getBillProcessDetail(params);
    return data;
  } catch (error) {
    return 0;
  }
});
